export default "__VITE_ASSET__6307e54d__"